import { useContext, useEffect, useState } from 'react';

import { AuthContext } from 'context/AuthContext';
import ErrorBoundaryContext from 'context/ErrorBoundaryContext';

import { fetchCompany, fetchCompanyLocations } from 'helpers/company';

export default function useCompany(hqId, { enabled = true } = {}) {
  const [isLoading, setIsLoading] = useState(true);
  const [company, setCompany] = useState();
  const [companyLocations, setCompanyLocations] = useState([]);
  const { user } = useContext(AuthContext);
  const { setError } = useContext(ErrorBoundaryContext);

  useEffect(() => {
    if (!user || !hqId || !enabled) {
      // the default state is loading, here, as you need
      // a company (except in the case of a Cuboh user)
      setIsLoading(true);
      setCompany(undefined);
      setCompanyLocations([]);
      return;
    }

    async function loadCompany() {
      setIsLoading(true);

      const [companyData, companyLocationsData] = await Promise.all([
        fetchCompany({ companyId: hqId, setError }),
        fetchCompanyLocations({ companyId: hqId, setError }),
      ]);

      setCompany(companyData);
      setCompanyLocations(companyLocationsData);
      setIsLoading(false);
    }

    loadCompany();
  }, [enabled, hqId, setError, user]);

  const refreshCompanyLocations = async () => {
    if (!user || !hqId || !enabled) return;

    const companyLocationsData = await fetchCompanyLocations({ companyId: hqId, setError });
    setCompanyLocations(companyLocationsData ?? []);
  };

  return [company, companyLocations, isLoading, refreshCompanyLocations];
}
